<!--
     <FieldStringArea>
-->

<template>
  <div class="qfieldstringarea-text">{{ representation }}</div>
</template>


<style>
 .qfieldstringarea-text {
   /* white-space: pre; */
   /* FIXME no owrk multiple lines */
   overflow-wrap: break-word; 
   white-space: pre-line;
 }
</style>


<script>
 export default {
   name: 'FieldStringArea',

   props: ['field'],

   computed: {
     representation() {
       return ''+this.field;
     },
   },
 }
</script>
